import { AutoContaninerFactory } from '@/class/cargo/model/utils/AutoContaninerFactory'

export class DataPushCompareUtils {
  static COMPARE_STRING = 'String'
  static COMPARE_NUMBER = 'Number'
  static COMPARE_DATE = 'Date'
  static COMPARE_DATE_MAP = {
    '船名': 'String',
    '航次': 'String',
    '港区': 'String',
    '设置温度': 'String',
    '危险品级别分类': 'String',
    '危险品联合国编号': 'String',
    '计划靠泊泊位': 'String',
    '实际靠泊泊位': 'String',
    '箱型': 'String',
    '箱种': 'String',
    '箱号': 'String',
    '封号': 'String',
    '集卡号': 'String',
    '卸货港': 'String',
    '目的港': 'String',
    '装货港': 'String',
    '实际件数': 'Number',
    '实际重量': 'Number',
    '实际体积': 'Number',
    '箱量': 'Number',
    '箱重': 'Number',
    '件数': 'Number',
    '重量': 'Number',
    '体积': 'Number',
    '开港日期': 'Date',
    '截港日期': 'Date',
    '计划离泊时间': 'Date',
    '实际离泊时间': 'Date',
    '计划靠泊时间': 'Date',
    '实际靠泊时间': 'Date',
    '集卡进场时间': 'Date',
    '集卡出场时间': 'Date',
    '进场时间': 'Date',
    '出场时间': 'Date',
    '运抵报文发送时间': 'Date',
    '码头放行信息': 'Date',
    '海关放行信息': 'Date'
  }
  /**
   * 比较发送变化的数据
   */
  static comparePushData(fieldName, fieldValue, recordId) {
    let check = false
    if (!AutoContaninerFactory.getInstance().job) {
      return check
    }
    const item = AutoContaninerFactory.getInstance().job.pushHistoryLogs
    if (!item || !fieldValue) {
      return check
    }
    const logs = []
    for (const k in item) {
      logs.push({ 'time': k, 'logs': item[k] })
    }
    for (const itemLog of logs) {
      if (check) break
      const lgs = itemLog['logs']
      for (const h of lgs) {
        if (fieldName === h.fieldName && h.targetValue) {
          if (this.COMPARE_DATE_MAP.hasOwnProperty(fieldName)) {
            const dateType = this.COMPARE_DATE_MAP[fieldName]
            if (this.COMPARE_STRING === dateType || this.COMPARE_DATE === dateType) {
              if (h.targetValue === fieldValue) {
                check = true
                break
              }
            } else if (this.COMPARE_NUMBER === dateType) {
              const value = Number(h.targetValue).toFixed(2)
              const value1 = Number(fieldValue).toFixed(2)
              if (value === value1) {
                check = true
                break
              }
            }
          }
        }
      }
    }
    return check
  }
}
